import AndimarPrivacyPolicy from '../themes1/AndimarPages/AndimarPrivacyPolicy';
import React from 'react';
import ThemeEightPrivacyPolicy from '../ThemeEight/ThemeEightPages/ThemeEightPrivacyPolicy';
import ThemeNinePrivacyPolicyScreen from '../ThemeNine/ThemeNinePages/ThemeNinePrivacyPolicyScreen';
import ThemeTenPrivacyPolicy from '../ThemeTen/ThemeTenPages/ThemeTenPrivacyPolicy';
import ThemeThreePrivacyPolicyScreen from '../ThemeThree/ThemeThreePages/ThemeThreeOffices';
import { connect } from 'react-redux';

const CommonPrivacyPolicyPage = props => {
	const getPage = () => {
		const themeType = props.home && props.home.operator && props.home.operator.theme_type;
		if (themeType === 1) {
			return <AndimarPrivacyPolicy />;
		} else if (themeType === 8) {
			return <ThemeEightPrivacyPolicy />;
		} else if (themeType === 3) {
			return <ThemeThreePrivacyPolicyScreen />;
		} else if (themeType === 9 || themeType === 4) {
			return <ThemeNinePrivacyPolicyScreen />;
		} else if (themeType === 10) {
			return <ThemeTenPrivacyPolicy />;
		}
	};

	return <div>{getPage()}</div>;
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
// function mapDispatchToProps(dispatch) {
//   return {
//     actions: bindActionCreators({ ...actions }, dispatch),
//   };
// }

export default connect(mapStateToProps, {})(CommonPrivacyPolicyPage);



// WEBPACK FOOTER //
// ./src/features/themes/common-pages/CommonPrivacyPolicyPage.js